import React from 'react';
import ExternalSvg from 'components/ExternalSvg';

const ShakeShackChicken = () => (
  <ExternalSvg customer="shakeshack" iconName="chicken" width="100%" height="90%" />
);

export default ShakeShackChicken;
